const menu = {
  main: {
    contracts: "Contracts"
  },
  userMenu: {
    logout: "Logout"
  },
}

export default menu;